var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1_4",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1_4",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAACp0lEQVR4nO2dO25UQRBFXwQhghgRVBPx2YW7QCL2CpBG9EWsgdAkWIAMbAZIIXhEwEIAh0aD2iMQCMae5HVVV98jVfym7unPaD7d00QIIYQQQgghhBBCyI48lL3bJenzIvlzET1G0nXkKqLHtVckffZA8i2zgfLo+t2LJeVXJeUf1qHASkbtXfTl/o39C83Dh+R31gHAT71tKgEpv3bQ9NpViR41XPPHXXawtfIJ0p2biwuoG659s+qyiujh4gIg+Yt1o/BbnxYXUES/O2h07bIkf1tcgHmTyXdRQKIA81EIzgD7IMAlyD4MGBT3gEQB5qMQnAH2QYBLkH0YMKiwe0BJ+aCIfrAOeEwBoo/rs1eydwmi761DHkuAbML/hXcJsQTI3+H3ICGOAPl/+N4lhBBQUj7Y5bVUCd425hgCJH+8f1Wv7CrB00wIIQAdSwgjAJ1KCCUAHUoIJwCdSQgpAB1JCCsAnUgILQAdSAgvAM4lLC6gR1YNJVj3Oo0uYSK2Es54PGkh4fQhxO4T1DMeTVYNPr5mysbfHWx7/tCsGn5xs3gzLZrA+TWXa/cuewt/FAGz1/BHEDB7Dj+6gNl7+JEFzD2EH1XA3Ev4EQXMPYUfTcDcW/iRBMw9hh9GQOFPE20F4LTyk55GfqgZgHMkeA0/oAD9R4Ln8IMK0N8SvIcfWIDyT3rWAtBJhZ0B6KQoIFGA+SgEZ4B9EOASZB8GDIp7QKIA81EIzgD7IBB1CeLBrbo1/CL56/J7AI8uXpseXVxvjrCe5vBaok8XF1Cv7dgc1e6g4TTg8fWVem2HfcPqqyS/mFpRr+uo13aYN518VEn6pvk9MqcSRI/GXo7ySR35zcP/k7ru1Zsj6juAEd6ilk2PtdfDZms+IYQQQgghhBBCCJki8BO1OB7yRvEDKwAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnter);
export default __webpack_public_path__ + "static/media/Enter.ab72ef480d4577d315cdac0463de57af.svg";
export { ForwardRef as ReactComponent };